import { Card, Col, Row, Space, Button, Spin, Select, Tag } from "antd";
import "../assets/css/evidence.css";
import React from "react";
import { StoreContext } from "../store/RootStore";
import testImage from "../assets/images/st-distributor-rentcar.jpg";
import testImage2 from "../assets/images/st-main-carbg.jpg";
import withRouter from "../withRouter";
import { observer } from "mobx-react";
const { Option } = Select;

class EvidenceDetails extends React.Component {
    constructor(props, context) {
        super(props);
        const query = new URLSearchParams(this.props.location.search);
        this.evidenceStore = context.evidenceStore;
        this.state = {
            id: query.get("id"),
            channel: '',
            alarmName: '',
            deviceId: query.get("deviceId"),
            filename: query.get("filename"),
            vehicleNo: '',
            driverName: '',
            alarmDate: '',
            model: '',
            companyId: this.props.getUserData().userCompanyId,
            sessionNo: '',// query.get("session"),
            visibleEvidence: [],
            fromDate: query.get("fromDate"),
            toDate: query.get("toDate"),
            invalidImages: {}
            // alarmId: query.get("alarmId"),
        };
    }
    getEvidenceData1 = async (page = 0) => {
        console.log(this.state.alarmId)
        const data = {
            companyId: this.state.companyId,
            // vehicleId: this.state.vehicleId,
            // driverId: this.state.selectedDrivers,
            fromDate: this.state.fromDate,
            toDate: this.state.toDate,
        };

        await this.evidenceStore.getEvidence(data, page);

        const evidence = this.evidenceStore.evidence; // full data from API
        if (evidence && evidence.length > 0) {
            this.setState({
                page: 1,
                update: 1,
                visibleEvidence: evidence.slice(0, this.state.itemsPerLoad), // show first few groups
                hasMore: evidence.length > this.state.itemsPerLoad
            });
        } else {
            this.setState({
                visibleEvidence: [],
                hasMore: false
            });
        }
    };

    getEvidenceData = async (page = 0) => {
        const data = {
            companyId: this.state.companyId,
            fromDate: this.state.fromDate,
            toDate: this.state.toDate,
        };

        await this.evidenceStore.getEvidence(data, page);

        const evidence = this.evidenceStore.evidence;

        if (evidence && evidence.length > 0) {

            const filteredEvidence = await Promise.all(
                evidence.map(async (group) => {

                    const validRecords = await Promise.all(
                        group.records.map(
                            (item) =>
                                new Promise((resolve) => {
                                    if (!item.filename) {
                                        resolve(null);
                                        return;
                                    }

                                    const img = new Image();

                                    img.onload = () => resolve(item);
                                    img.onerror = () => resolve(null);

                                    img.src = item.filename;
                                })
                        )
                    );

                    return {
                        ...group,
                        records: validRecords.filter(Boolean)
                    };
                })
            );

            // Remove date groups having no valid records
            const finalEvidence = filteredEvidence.filter(
                group => group.records.length > 0
            );

            this.setState({
                page: 1,
                update: 1,
                visibleEvidence: finalEvidence.slice(0, this.state.itemsPerLoad),
                hasMore: finalEvidence.length > this.state.itemsPerLoad
            });
        } else {
            this.setState({
                visibleEvidence: [],
                hasMore: false
            });
        }
    };

    handleCardClick = async (item) => {
        console.log("item", item.filename)
        await this.setState({
            //sessionNo: item.sessionNo,
            alarmDate: item.startTime,
            vehicleNo: item.vehicleNo,
            driverName: item.driverName,
            alarmName: item.alarmName,
            model: item.model,
            filename: item.filename,
            vdofilename: item.vdofilename,
            //channel: item.value
        })
    };


    renderEvidence(group) {
        console.log("object", group)


        const dateLabel = new Date(group.alarmDate).toLocaleDateString("en-US", {
            day: "numeric", month: "long", year: "numeric"
        });

        return (
            <div key={group.alarmDate} style={{ marginBottom: "24px" }}>
                {/* Date heading */}
                <p style={{ marginBottom: 16, fontSize: "16px", fontWeight: 600 }}>
                    {dateLabel}
                </p>

                <div className="evidence-list-details">
                    {group.records.map((item) => {

                        if (!item?.id) {
                            console.log("Skipping invalid record", item);
                            return null;
                        }



                        return (
                            <Card
                                key={item?.deviceId == 13 ? `${item.howenId}` : `${item.bsjId}`}
                                hoverable
                                className="evidence-list-card"
                                onClick={() => this.handleCardClick(item)}
                            >
                                <div className="card-horizontal">
                                    {/* Video (left) */}
                                    <div className="video-wrapper">
                                        {item?.deviceId == 13 ?
                                            <img
                                                src={item.filename}
                                                alt={item.alarmName}
                                                style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    objectFit: "cover", // or "contain"
                                                    display: "block"
                                                }}
                                                onError={(e) => {
                                                    e.currentTarget.parentElement.innerHTML =
                                                        "<div style='padding:20px;text-align:center'>Image not available</div>";
                                                }}
                                            /> :
                                            <iframe
                                                src={item.filename}
                                                frameBorder="0"
                                                allow="autoplay"
                                            />
                                        }


                                    </div>

                                    {/* Info (right) */}
                                    <div className="card-info">
                                        <div style={{ fontSize: "14px", fontWeight: 600 }}>
                                            Vision: {item.alarmName}
                                        </div>
                                        <div style={{ fontSize: "13px", color: "#555" }}>
                                            {item.startTime}
                                        </div>
                                        <div style={{ fontSize: "13px", color: "#444" }}>
                                            {item.model
                                                ? `${item.model} - (${item.vehicleNo})`
                                                : `(${item.vehicleNo})`}
                                        </div>
                                        <div style={{ fontSize: "13px", color: "#444" }}>
                                            {item.driverName ? item.driverName : "-"}
                                        </div>
                                    </div>
                                </div>
                            </Card>
                        );
                    })}
                </div>
            </div>
        );
    }


    async componentDidMount() {
        const query = new URLSearchParams(this.props.location.search);
        console.log(query.get("vdofilename"))

        if (Number(this.props.getUserData().isadmin) !== -1) {
            let companyId = this.props.getUserData().userCompanyId;
            this.setState({ companyId: companyId });
        }

        const data = {
            id: this.state.id,
        }
        console.log("componentDidMount sdata", data);
        const result = await this.evidenceStore.getDetailedVideo(data);

        console.log("result", result);
        await this.setState({
            alarmName: result.alarmName,
            vehicleNo: result.vehicleNo,
            driverName: result.driverName,
            alarmDate: result.alarmDate,
            model: result.model,
            sessionNo: result.sessionNo,
            vdofilename: query.get("vdofilename"),
        });
        await this.getEvidenceData();

        const evidence = await this.evidenceStore.evidence;
        console.log("evidence", evidence);
        if (evidence && evidence.length > 0) {
            this.setState({
                page: 1,
                update: 1,
                visibleEvidence: evidence.slice(0, this.state.itemsPerLoad), // show first few groups
                hasMore: evidence.length > this.state.itemsPerLoad
            });
        } else {
            this.setState({
                visibleEvidence: [],
                hasMore: false
            });
        }

    }
    render() {
        const { alarmName, vehicleNo, driverName, alarmDate, model, sessionNo, channel, vdofilename, deviceId } = this.state;
        console.log(this.state.deviceId)
        return <>
            <div style={{ padding: 0 }}>
                <Row className="headerFixed" style={{ height: "50px" }}>
                    <Col span={12}>
                        <div className="heading">
                            {this.context.translate("_EVIDENCE_")}
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="evidence-container">
                <div className="filter-toolbar-container">
                    <div className="filter-bar">
                        <div
                            style={{
                                fontSize: "14px",
                                fontWeight: 500,
                                color: "#000"
                            }}
                        >
                            <p>Replay Video from Trackeazy: Following {alarmName} that occured on {alarmDate}  </p>

                        </div>

                    </div>
                </div>

                <div className="evidence-details">
                    <div>
                        <Card hoverable className="evidence-video-card">
                            <div>
                                {/* {this.state.deviceId == 13 ?
                                    <iframe
                                        key={`evidence-video-${sessionNo}-${channel}`}
                                        src={filename}
                                        width="100%"
                                        height="500px"
                                        objectFit="fill"
                                        frameBorder="0"
                                    />
                                    :
                                    <video

                                        src={filename}
                                        controls
                                        muted
                                        style={{ width: '100%', height: "75%", background: '#000', objectFit: 'fill', maxHeight: "80%", display: "block", }}
                                    />
                                } */}
                                <video

                                    src={vdofilename}
                                    autoPlay
                                    muted
                                    controls
                                    playsInline
                                    style={{ width: '100%', height: "500px", background: '#000', objectFit: 'fill', maxHeight: "80%", display: "block", }}
                                />

                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: 4,
                                        marginLeft: 10
                                    }}
                                >
                                    <div
                                        style={{
                                            fontSize: "14px",
                                            fontWeight: 600,
                                            color: "#000"
                                        }}
                                    >
                                        Vision: {alarmName}
                                    </div>
                                    <div style={{ fontSize: "13px", color: "#555" }}>
                                        Event time : {alarmDate}
                                    </div>
                                    <div style={{ fontSize: "13px", color: "#555" }}>
                                        Event Video Retrieval Time(GPS): {alarmDate}
                                    </div>
                                    <div style={{ fontSize: "13px", color: "#444" }}>
                                        {model
                                            ? `${model} - (${vehicleNo})`
                                            : `(${vehicleNo})`}
                                    </div>

                                </div>

                            </div>

                        </Card>
                    </div>

                    <div className="scrollable-panel">
                        <Row gutter={[16, 16]} className="evidence-details-grid">

                            {this.state.visibleEvidence && this.state.visibleEvidence.length > 0
                                ? this.state.visibleEvidence.map(group => this.renderEvidence(group))
                                : (
                                    <Col span={24} style={{ textAlign: "center", padding: "50px 0", color: "#999" }}>
                                        No data available
                                    </Col>
                                )}

                        </Row>

                    </div>

                </div>

            </div>


        </>;
    }
}
EvidenceDetails.contextType = StoreContext;
export default observer
    (withRouter(EvidenceDetails));
// export default withRouter(EvidenceDetails);